(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hotness-filter"] && !Shopify.designMode) return;
  try {
    class HotnessFilterComponent extends HTMLElement {
    connectedCallback() {
      this._buttons = Array.from(this.querySelectorAll('.hotness-filter__btn'));
      this._inputs = Array.from(this.querySelectorAll('.hotness-filter__input'));
      this._buttons.forEach(btn => {
        btn.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();
          this._handleClick(parseInt(btn.dataset.level, 10));
        });
        btn.addEventListener('mouseenter', () => {
          const l = parseInt(btn.dataset.level, 10);
          this._buttons.forEach(b => {
            b.classList.toggle('hotness-filter__btn--hover', parseInt(b.dataset.level, 10) <= l);
          });
        });
        btn.addEventListener('mouseleave', () => {
          this._buttons.forEach(b => b.classList.remove('hotness-filter__btn--hover'));
        });
      });
    }

    _handleClick(level) {
      const current = this._activeLevel();
      const next = current === level ? 0 : level;
      this._inputs.forEach(input => {
        input.checked = next > 0 && parseInt(input.value, 10) === next;
      });
      this._buttons.forEach(btn => {
        const l = parseInt(btn.dataset.level, 10);
        btn.classList.toggle('hotness-filter__btn--active', next > 0 && l <= next);
        btn.setAttribute('aria-pressed', next > 0 && l <= next ? 'true' : 'false');
      });
      const first = this._inputs[0];
      if (first) first.dispatchEvent(new Event('change', { bubbles: true }));
    }

    _activeLevel() {
      const active = this._inputs.find(i => i.checked);
      return active ? parseInt(active.value, 10) : 0;
    }
  }

  if (!customElements.get('hotness-filter-component')) {
    customElements.define('hotness-filter-component', HotnessFilterComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
